var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M34.867 4.467a26.2 26.2 0 0 0-5.7-.634 13.77 13.77 0 0 0-10 3.434 1200 1200 0 0 0-5.317 5.35c-2.017-.217-6.8-.334-10 2.9a1.667 1.667 0 0 0 0 2.35l18.833 18.866a1.667 1.667 0 0 0 2.35 0c3.25-3.333 3.15-8.033 2.95-10l5.35-5.333c5.317-5.317 2.9-15.3 2.8-15.717a1.67 1.67 0 0 0-1.266-1.216M30.933 19.05 25 24.95a1.67 1.67 0 0 0-.45 1.5 11.35 11.35 0 0 1-.9 6.567L7.533 16.867a11.1 11.1 0 0 1 6.667-.834 1.67 1.67 0 0 0 1.45-.533s2.333-2.417 5.85-5.933a11.02 11.02 0 0 1 7.667-2.4c1.301.006 2.6.118 3.883.333.4 2.383 1.033 8.4-2.117 11.55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.217 17.667a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667M8.333 27.167C5 28.834 5 35.5 5 35.5a13.02 13.02 0 0 0 8.333-3.333z"
  })));
};
export default SvgRocket;